import React, { Component } from "react";
import ArticleCommentsV2 from "./ArticleCommentsV2";
import AdChitika from "../Ads/AdChitika";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import { db, firebase } from '../firebase';

class ArticleBase extends Component {

  constructor(props) {
    super(props);

    this.state = {
      articleId: this.props.match.params.articleId,
      ArticleBody: "",
      articleName: "",
      author: "",
      date: new Date(),
      commentData: []
    };

    this.postHandler = this.postHandler.bind(this);
  }

  componentDidMount () {
    var thethis = this;

    db.getComments(this.state.articleId).then(snapshot =>
      thethis.setState(() => (
        { commentData: ("Comments" in snapshot ? snapshot.Comments : []),
          ArticleBody: snapshot.article,
          articleName: snapshot.articleName,
          author: snapshot.author,
          date: snapshot.date }))
    );

  }

  postHandler (comments) {
      this.setState({commentData: comments})
  }


  render() {
    var spacerStyle = {
      marginTop: "70px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var size13 = {
      fontSize: 13
    }

    var adStyle={
      justifyContent: "center",
      marginBottom: 5
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
      <div style={adStyle} className="row">
      <AdChitika publisher="Gaztingo" />
      </div>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">
        <h1>{this.state.articleName}</h1>

        <p style={size13}>
          By: {this.state.author} - {this.state.date.toLocaleDateString()}
        </p>

        <ReactQuill id="article" readOnly={true} value={this.state.ArticleBody}  theme="bubble" />
        </div>
          <ArticleCommentsV2 articleId={this.state.articleId} comments={this.state.commentData} postHandler={this.postHandler} />
      </div>


    );
  }
}

export default ArticleBase;



// WEBPACK FOOTER //
// ./src/Articles/ArticleBase.js